import React, { useState, useEffect } from "react";
import Textfield from "@atlaskit/textfield";
import { useSelector, useDispatch } from "react-redux";
import { setImportSourceName } from "../../../redux/actions/jiraAssetsActions";
const ImportSourceName = ({defaultImportSourceName}) => {
  const importSourceName = useSelector((state) => state.jiraAssets.importSourceName);
  const dispatch = useDispatch();
  const onChange = (e) => {
    dispatch(setImportSourceName(e.target.value))
  };
  useEffect(() => {
    dispatch(setImportSourceName(defaultImportSourceName))
  }, []);

  return (
    <div >
        Import Source Name:
        <Textfield value={importSourceName} onChange={onChange}/>
        This field sets the name of the import definition in assets.
    </div>
  );
};

export default ImportSourceName;
